import { render, staticRenderFns } from "./WindowStack.vue?vue&type=template&id=ab48be80&"
import script from "./WindowStack.vue?vue&type=script&lang=js&"
export * from "./WindowStack.vue?vue&type=script&lang=js&"
import style0 from "./WindowStack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports